


























































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { LoginValidationErrors } from '../store/modules/auth/types';
import { AuthData } from '../models/auth';
import { LoginData } from '../models/login';
import { InviteToAccept } from '../models/inviteToAccept';

@Component({
  name: 'Login',
})
export default class Login extends Vue {
  @Action('auth/login') loginAct!: () => Promise<AuthData | string>;
  @Action('auth/setLoginData') setLoginData!: (loginData: LoginData) => void;
  @Action('org/fetchOrgData') fetchOrgData!: (orgName: string) => Promise<void>;
  @Action('profile/sharing/accept') acceptInvitation!: (
    invite: InviteToAccept
  ) => Promise<void>;

  @Getter('auth/getLoginData') getLoginData!: () => LoginData;
  @Getter('auth/getLoginErrors') getLoginErrors!: () => LoginValidationErrors;
  @Getter('org/getLogoUrl') getLogoUrl!: () => string;
  @Getter('org/getName') getOrgName!: () => string;

  @Ref() readonly signUpForm!: HTMLFormElement;

  errorMessage = '';
  formValidity = false;
  loading = false;
  showPassword = false;
  submiting = false;
  invitation;

  created() {
    if (localStorage.getItem('tokenExpired')) {
      this.errorMessage = 'Your session has expired!';

      // Let's clear the token expired param
      localStorage.removeItem('tokenExpired');
    }

    if (this.$route.params.org) {
      this.loading = true;
      this.fetchOrgData(this.$route.params.org)
        .then(() => (this.loading = false))
        .catch(() => this.$router.push('/notfound'));
    }

    if (
      this.$route.query.invite != undefined &&
      this.$route.query.user != undefined
    ) {
      const invitation: InviteToAccept = {
        invitationUuid: this.$route.query.invite as string,
        inviterUuid: this.$route.query.user as string,
      };

      this.invitation = invitation;
    }
  }

  login() {
    if (!this.formValidity) {
      this.signUpForm.validate();
      return;
    }

    this.submiting = true;

    this.loginAct()
      .then(() => {
        if (this.invitation != undefined) {
          this.acceptInvitation(this.invitation);
        }

        (this.$refs.signUpForm as Vue & {
          resetValidation: () => boolean;
        }).resetValidation();
        this['$router'].push('/home');
      })
      .catch(error => {
        this.submiting = false;
        this.errorMessage = error;
      });
  }
}
